export default {
  title: 'Export',
  home: 'Home'
}
